import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminTopbar from './AdminTopbar';
import AdminFooter from './AdminFooter';
import PageTransition from './PageTransition';
import { useSmoothScroll } from '../../hooks/useSmoothScroll';

const AdminLayout: React.FC = () => {
  useSmoothScroll();
  
  React.useEffect(() => {
    document.body.id = 'kt_app_body';
    document.body.setAttribute('data-kt-app-layout', 'light-sidebar');
    document.body.setAttribute('data-kt-app-header-fixed', 'true');
    document.body.setAttribute('data-kt-app-sidebar-enabled', 'true');
    document.body.setAttribute('data-kt-app-sidebar-fixed', 'true');
    document.body.setAttribute('data-kt-app-sidebar-hoverable', 'true');
    document.body.setAttribute('data-kt-app-sidebar-push-header', 'true');
    document.body.setAttribute('data-kt-app-sidebar-push-toolbar', 'true');
    document.body.setAttribute('data-kt-app-sidebar-push-footer', 'true');
    document.body.setAttribute('data-kt-app-toolbar-enabled', 'true');
    document.body.className = 'app-default';
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-root app-root" id="kt_app_root" style={{ minHeight: '100vh' }}>
        <div className="app-page flex-column flex-column-fluid" id="kt_app_page" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <AdminTopbar />
          <div className="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <AdminSidebar />
            <div className="app-main flex-column flex-row-fluid" id="kt_app_main" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <PageTransition>
                <div style={{ flex: 1 }}>
                  <Outlet />
                </div>
              </PageTransition>
            </div>
            <AdminFooter />
          </div>
        </div>
      </div>
      
      <div id="kt_scrolltop" className="scrolltop" data-kt-scrolltop="true" style={{ cursor: 'pointer', display: 'none' }}>
        <span className="svg-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)" fill="currentColor" />
            <path d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z" fill="currentColor" />
          </svg>
        </span>
      </div>
    </>
  );
};

export default AdminLayout;

